import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select'
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogos , cargarCatalogosGenericoAsync, cargarCatalogosAsync} from '../../funciones_globales/catalogos';
import styled from 'styled-components';

const LabelTipoReporte = styled.label`
  display: inline;
  font-size: 12px;
  color: green;
`;

const ContenedorToggle = styled.span`
  margin-left: 15px;
`;


class FormVen19  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            opt_tipos: [],
            opt_zonas: [],
            tipo_sel: null,
            zona_sel: null,
            ciudad_sel: null,
            cliente_sel: null,
            vendedor_sel: null,
            articulo_sel: null,
            detalle: false,
            todo: true
        };

        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.imprimirReporteDevoluciones = this.imprimirReporteDevoluciones.bind(this);
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0419');
        let fechaProceso = getFechaProcesoPorModulo('04');

        Promise.all([
            cargarCatalogos('TIPODEVO'),
            cargarCatalogos('ZONACLIEN')
        ])
        .then(([ tipos, zonas ]) => {
            this.setState({
                fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
                opt_tipos: tipos,
                opt_zonas: zonas
            });
        })
        .catch((error)=>{
            alert(`Catálogos del formulario no han sido cargados. Ocurrió el error: ${error}`);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0419');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04');        

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
            tipo_sel: null,
            zona_sel: null,
            cliente_sel: null,
            vendedor_sel: null,
            articulo_sel: null,
            ciudad_sel: null,
            detalle: false,
            todo: true
        });
    }    

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 3 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;     
          cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    imprimirReporteDevoluciones(){
        try{

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

            let urlReportWithParams = '';
            let tipoRpt = '';

            if(this.state.todo===true){
                if(this.state.detalle===false){
                    // Reporte de desglose de devoluciones
                    urlReportWithParams=`&rpt=46`;
                    tipoRpt = 'DESG-DEVOLUCIONES';
                }else{
                    // Reporte de desglose de devoluciones con detalle de artículos.
                    urlReportWithParams=`&rpt=78`;
                    tipoRpt = 'DESG-DEVOLUCIONES-CONARTIC';
                }
            }else{
                // Reporte de resumen de devoluciones.
                urlReportWithParams=`&rpt=77`;
                tipoRpt = 'RESUMEN-DEVOLUCIONES';
            }

            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            if(this.state.tipo_sel){
                urlReportWithParams+=`&param3=${this.state.tipo_sel.value}`;
            }
            if(tipoRpt!=='RESUMEN-DEVOLUCIONES'){
                if(this.state.zona_sel){
                    urlReportWithParams+=`&param4=${this.state.zona_sel.value}`;
                }
            }else{
                if(this.state.ciudad_sel){
                    urlReportWithParams+=`&param4=${this.state.ciudad_sel.value}`;
                }
            }            
            if(this.state.cliente_sel){
                urlReportWithParams+=`&param5=${this.state.cliente_sel.value}`;
            }
            if(this.state.vendedor_sel){
                urlReportWithParams+=`&param6=${this.state.vendedor_sel.value}`;
            }
            
            if(tipoRpt==='DESG-DEVOLUCIONES-CONARTIC'){                
                if(this.state.articulo_sel){
                    urlReportWithParams+=`&param7=${this.state.articulo_sel.value}`;
                }
            }

            visualizarReporteEnPdf(urlReportWithParams);
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Devoluciones</TituloForm>
                </HeaderForm>
                <CuerpoForm>                
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-5'>
                            <LabelTipoReporte>{this.state.todo?'Reporte DESGLOSE Devoluciones': 'Reporte RESUMEN Devoluciones'}</LabelTipoReporte>
                            <ContenedorToggle>
                                <ToggleSwitch
                                    checked={this.state.todo}
                                    onChange={() => {this.setState({ todo: !this.state.todo });}}
                                    size='sm'
                                />
                            </ContenedorToggle>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                        
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Motivo Dev.:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelect options={ this.state.opt_tipos } value={this.state.tipo_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({tipo_sel: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10} isInvisible={!this.state.todo}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Zona:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelect options={ this.state.opt_zonas } value={this.state.zona_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({zona_sel: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10} isInvisible={this.state.todo}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Ciudad:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.ciudad_sel} func_loadOptions={this.getOptions_Ciudad} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({ciudad_sel: value});}}/>
                        </ContainerCol>
                    </Row> 
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vendedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({vendedor_sel: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cliente_sel: value});}}/>
                        </ContainerCol>
                    </Row> 
                    <Row margen_arriba={10} isInvisible={!this.state.todo}>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Detalle de artículos?:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <input type='checkbox' name='detalle' checked={this.state.detalle} 
                            onChange={this.handleInputChange}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10} isInvisible={this.state.detalle===true?false:true}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Articulo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.articulo_sel} func_loadOptions={this.getOptions_Articulos} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({articulo_sel: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirReporteDevoluciones}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVen19);